import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-325ee239"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "startChoice" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "headerwave" }, null, -1))
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "wordForUnderline" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "underline",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 150",
  preserveAspectRatio: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.1,133.6c0,0,173.4-20.6,328.3-14.5c154.8,6.1,162.2,8.7,162.2,8.7s-262.6-4.9-339.2" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = {
  class: "actionInfo",
  style: {"margin":"3rem"}
}
const _hoisted_8 = { class: "optionsWrapper" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.company?.DisplayedTexts["Bevor wir starten"]) + ":", 1),
      _createElementVNode("h2", null, [
        _createTextVNode(_toDisplayString(_ctx.company?.DisplayedTexts["Für welchen"]) + " ", 1),
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.company?.DisplayedTexts["Anlass"]) + " ", 1),
          _hoisted_5
        ]),
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.company?.CompanyQuizConfig?.UseFormalSalutation ? 
				
					_ctx.company.DisplayedTexts["suchen Sie ein Produkt"]
					:
					_ctx.company?.DisplayedTexts["suchst du ein Produkt"]) + "? ", 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.company?.Quiz.getCurrentQuestion().Headline ?? _ctx.company?.DisplayedTexts["Bitte auswählen"]), 1),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (answer) => {
          return (_openBlock(), _createElementBlock("div", {
            key: answer.Id,
            class: _normalizeClass(["selectOptions", { disabled: answer.Value === 'disabled' }])
          }, [
            _createElementVNode("img", {
              src: answer.Picture ?? '',
              alt: answer.Text ?? ''
            }, null, 8, _hoisted_9),
            _createElementVNode("button", {
              disabled: answer.Value === 'disabled',
              onClick: ($event: any) => (_ctx.answerClicked(answer)),
              style: _normalizeStyle(_ctx.company?.FrontendDesign?.BackgroundColor?.toLowerCase() === '#1e1e1e' && _ctx.company.FrontendDesign.PrimaryColor?.toLowerCase() !== '#ffffff' ? 'color: #ffffff' : _ctx.company?.FrontendDesign?.BackgroundColor)
            }, _toDisplayString(answer.Value === "disabled" ? "Coming Soon!" : answer.Text), 13, _hoisted_10)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}